/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CompleteSquareWorkflowRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'
import {CompleteSquareWorkflowResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'


export const completeSquareWorkflow = (request:CompleteSquareWorkflowRequest, options?: CashRequestOptions) => post<CompleteSquareWorkflowRequest, CompleteSquareWorkflowResponse>("/2.0/cash/complete-square-workflow", request, {...options, rejectOnError: true })